<script setup lang="ts">
const { locales } = useLocales();
const available = computed(() => locales.available.filter(({ code }) => code !== locales.current.code));
</script>

<template>
  <a v-for="locale in available" :key="locale.code" :href="locale.url" class="locale-link">
    {{ locale.name }}
  </a>
</template>
